const AnjuPlacementsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/3hEyr112NkmziqWp5PWzlt?si=4635bf8a2ce942c7" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273d27409c904dea9363500f85e" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - March 2nd</strong><br/>
                (prod. ANJU Online!)
              </p>
            </a>
        </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1zHJmzl14ElbLxrlXB70zF?si=b9106df0ae8e46f3" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b2734c59a716d7f33efa25b82c74" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Catalyst</strong><br/>
                (prod. ANJU Online!)
              </p>
            </a>
        </div>

        <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/7dj4Rf9bwDANLQLHQhycne?si=195758df3bc740fc" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-il9NATXFnn8xquQe-onkrAQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Slime Cry</strong><br/>
                (prod. ANJU Online!)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1AYPa7Fn3NhxQXzU6Z5jsA?si=be828dc4843b40fa" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QD3RqZW3V4fKs7pr-jNLnBQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lugosi - ghostsinthewalls</strong><br/>
                (Prod. ANJU Online!)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/kawaiiry-we-all-change-its-okay-prod-anjuonline" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - we all change and thats okay</strong><br/>
                (Prod. ANJU Online!)
              </p>
            </a>
          </div>  

        </div>
      </>
    );
  };
  export default AnjuPlacementsStatic;